import * as React from "react";
import { connect } from "react-redux";
import { IWithContextProp, withContext } from "../../../../shared/hoc/with-context";
import { IWithHistoryProp, withHistory } from "../../../../shared/hoc/with-history";
import { withManagement } from "../../../../shared/hoc/with-management";
import { showDomainAccessRequiredModal } from "../../../../store/domain-access-modal/actions";

export interface IBillingsState {}

export interface IBillingsProps {
  showDomainAccessRequiredModal: (actionName: string | string[]) => void;
}

class Billing extends React.PureComponent<IBillingsProps & IWithContextProp & IWithHistoryProp, IBillingsState> {
  constructor(props: IBillingsProps & IWithContextProp & IWithHistoryProp) {
    super(props);
    this.state = {};
  }

  async componentDidMount() {}

  render() {
    return (
      <>
        <div>
          <></>

          <iframe
            style={{ width: "100%", height: "98vh" }}
            src="https://billing.stripe.com/p/login/test_00g9DgccL7ZAgQ8144"
          ></iframe>
        </div>
      </>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    showDomainAccessRequiredModal: (accessName) => dispatch(showDomainAccessRequiredModal(accessName))
  };
};

const billing = connect(
  null,
  mapDispatchToProps
)(withContext<IBillingsProps>(withManagement<IBillingsProps>(withHistory<IBillingsProps>(Billing))));
export { billing as Billing };
